'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const TickIncrementCalculator=require('../../../../../../dist-es6/client/directives/plotting/tickIncrementCalculator');let

IncidentBucketType=function(){
function IncidentBucketType(label,propertyOnIncidentVM,createInitialBucketViewData,getDomain,getTickInfo){_classCallCheck(this,IncidentBucketType);
_.ensureInstanceOf('function',getTickInfo);

this._label=label;
this._propertyOnIncidentVM=propertyOnIncidentVM;
this._createInitialBucketViewData=createInitialBucketViewData;
this._getDomain=getDomain;
this._getTickInfo=getTickInfo;

this._previousBucketGenerationArgs={
timezone:null,
interval:null};


this._previouslyGeneratedInitialViewData=null;
}IncidentBucketType.prototype.





getTickInfo=function getTickInfo(interval,widthOnScreen){
return this._getTickInfo(interval,widthOnScreen);
};IncidentBucketType.prototype.

getBucketFor=function getBucketFor(incident){
return incident[this._propertyOnIncidentVM];
};IncidentBucketType.prototype.

getDomain=function getDomain(interval){
return this._getDomain(interval);
};IncidentBucketType.prototype.

getAllBuckets=function getAllBuckets(interval,timezone){
return this.getAllBucketsWithInitialViewData(interval,timezone,{skipSizes:!0}).buckets;
};IncidentBucketType.prototype.

getBucketIndexMap=function getBucketIndexMap(interval,timezone){
return this.getAllBucketsWithInitialViewData(interval,timezone,{skipSizes:!0}).bucketIndexMap;
};IncidentBucketType.prototype.

getAllBucketsWithInitialViewData=function getAllBucketsWithInitialViewData(interval,timezone,options){
if(!this._hasExistingDataAndSameGenerationArgs(interval,timezone)){
this._previouslyGeneratedInitialViewData=this._createInitialBucketViewData(interval,timezone);
this._previousBucketGenerationArgs.interval=interval;
this._previousBucketGenerationArgs.timezone=timezone;
}

return this._getCleanInitialViewData(options);
};IncidentBucketType.prototype.

_hasExistingDataAndSameGenerationArgs=function _hasExistingDataAndSameGenerationArgs(interval,timezone){
return _.exists(this._previouslyGeneratedInitialViewData)&&
this._previousBucketGenerationArgs.interval.equals(interval)&&
this._previousBucketGenerationArgs.timezone===timezone;
};IncidentBucketType.prototype.

_getCleanInitialViewData=function _getCleanInitialViewData(){let{skipSizes=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
return{
buckets:this._previouslyGeneratedInitialViewData.buckets,
bucketIndexMap:this._previouslyGeneratedInitialViewData.bucketIndexMap,
bucketSizes:skipSizes?null:Array.from(this._previouslyGeneratedInitialViewData.bucketSizes,_.clone)};

};IncidentBucketType.

fromConfig=function fromConfig(_ref){let{label:label,propertyOnIncidentVM:propertyOnIncidentVM,createInitialBucketViewData:createInitialBucketViewData,getDomain:getDomain,getTickInfo:getTickInfo}=_ref;
return new IncidentBucketType(label,propertyOnIncidentVM,createInitialBucketViewData,getDomain,getTickInfo);
};IncidentBucketType.

getBucketTypes=function getBucketTypes(){let{use24HourTimeline=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
return use24HourTimeline?
AllTypesWith24HourLabels:
AllTypesWith12HourLabels;
};_createClass(IncidentBucketType,[{key:'label',get:function(){return this._label}}],[{key:'Types',get:function()

{
return Types;
}}]);return IncidentBucketType}();


const epoch=new Date(0);

const _byDateTickIncrementCalculator=new TickIncrementCalculator([{
interval:'days',
steps:[1,2,8,14]},
{
interval:'months',
steps:[1,3,6]},
{
interval:'years',
steps:[1,2,5,10,50,100]}]);


function _getByDateMinorTickFormatterFor(tickInfo){
switch(tickInfo.interval){
case'days':
if(tickInfo.step===14){
return function(date){
if(date.getDate()>28){
return'';
}
return d3.time.format('%d')(date);
};
}else{
return'%d';
}
case'months':
return'%b';
case'years':
return'%Y';
default:
return'';}

}

function _generateFirstTickOrFirstOfPeriodFormatter(shouldSqueezeInAsFirstTick,isFirstOfPeriod,formatState,formatString){
const d3Formatter=d3.time.format(formatString);
return function(date){
if(!formatState.sawFirstTick){
formatState.sawFirstTick=!0;
if(isFirstOfPeriod(date)||shouldSqueezeInAsFirstTick(date)){
return d3Formatter(date);
}
}else if(isFirstOfPeriod(date)){
formatState.sawFirstTick=!0;
return d3Formatter(date);
}
return'';
};
}

function _getByDateMajorTickFormatterFor(tickInfo,formatState){
switch(tickInfo.interval){
case'days':
return _generateFirstTickOrFirstOfPeriodFormatter(
function(d){return tickInfo.step<8&&d.getDate()<27},
function(d){return d.getDate()===1},
formatState,
'%b');
case'months':
return _generateFirstTickOrFirstOfPeriodFormatter(
function(d){return tickInfo.step<3&&d.getMonth()<10},
function(d){return d.getMonth()===0},
formatState,
'%Y');
case'years':
return'';}

}

const dateBucketTypeConfig={
label:'Date',
propertyOnIncidentVM:'dateString',
createInitialBucketViewData:function(interval,timezone){
const spanningIntervals=interval.getSpanningIntervals('days',1,timezone);
const numBuckets=spanningIntervals.length;

const buckets=Array(numBuckets);
const bucketSizes=Array(numBuckets);
const bucketIndexMap=new Map;
for(let i=0;i<numBuckets;i++){
const bucket=Formatters.formatInLocale(spanningIntervals[i].start,'YYYY-MM-DD',timezone,{displayTimeZone:!1});
buckets[i]=bucket;
bucketSizes[i]=fourZeroes();
bucketIndexMap.set(bucket,i);
}

return{
buckets:buckets,
bucketIndexMap:bucketIndexMap,
bucketSizes:bucketSizes};

},
getDomain:function(interval){return[d3.time.day(interval.start),d3.time.day(interval.end)]},
getTickInfo:function(interval,widthOnScreen){
const idealPixelsPerMinorTick=32;
const idealTicks=widthOnScreen/idealPixelsPerMinorTick;
const calculated=_byDateTickIncrementCalculator.calculate(interval.duration,idealTicks);

const formatState={};
const tickStuff={
major:{
ticks:d3.time[calculated.minor.interval],
step:calculated.minor.step,
format:_getByDateMajorTickFormatterFor(calculated.minor,formatState)},

minor:{
ticks:d3.time[calculated.minor.interval],
step:calculated.minor.step,
format:_getByDateMinorTickFormatterFor(calculated.minor)}};



return tickStuff;
}};


const fourZeroes=function(){return[0,0,0,0]};

const numTimeOfDayBuckets=24;
const timeOfDayBuckets=Array(numTimeOfDayBuckets);
const timeOfDayBucketSizes=Array(numTimeOfDayBuckets);
const timeOfDayBucketsIndexMap=new Map;
for(let i=0;i<numTimeOfDayBuckets;i++){
const bucket=_.padStart(i.toString(),2,'0')+':00';
timeOfDayBuckets[i]=bucket;
timeOfDayBucketSizes[i]=fourZeroes();
timeOfDayBucketsIndexMap.set(bucket,i);
}

const timeOfDayInterval=TimeInterval.from(d3.time.day(epoch)).spanning(timespan.fromHours(23));
const timeOfDayBucketDomain=[timeOfDayInterval.start,timeOfDayInterval.end];
const timeOfDay12HourMinorTickConfig={
ticks:d3.time.hour,
step:2,
format:'%I:%M'};


const timeOfDay12HourBucketTypeConfig={
label:'Time of Day',
propertyOnIncidentVM:'hourString',
createInitialBucketViewData:function(){
return{
buckets:timeOfDayBuckets,
bucketSizes:timeOfDayBucketSizes,
bucketIndexMap:timeOfDayBucketsIndexMap};

},
getDomain:function(){return timeOfDayBucketDomain},
getTickInfo:function(interval,widthOnScreen){return{minor:timeOfDay12HourMinorTickConfig}}};


const timeOfDay24HourMinorTickConfig=_.defaults({
format:'%H:%M'},
timeOfDay12HourMinorTickConfig);

const timeOfDay24HourBucketTypeConfig=_.defaults({
getTickInfo:function(interval,widthOnScreen){return{
minor:timeOfDay24HourMinorTickConfig}}},

timeOfDay12HourBucketTypeConfig);

const dayOfWeekBuckets=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const dayOfWeekBucketSizes=[
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes(),
fourZeroes()];

const dayOfWeekBucketsIndexMap=new Map([
[dayOfWeekBuckets[0],0],
[dayOfWeekBuckets[1],1],
[dayOfWeekBuckets[2],2],
[dayOfWeekBuckets[3],3],
[dayOfWeekBuckets[4],4],
[dayOfWeekBuckets[5],5],
[dayOfWeekBuckets[6],6]]);

const dayOfWeekInterval=TimeInterval.from(d3.time.week(epoch)).spanning(timespan.fromDays(6));
const dayOfWeekBucketDomain=[dayOfWeekInterval.start,dayOfWeekInterval.end];
const dayOfWeekBucketTypeConfig={
label:'Day of Week',
propertyOnIncidentVM:'dayOfWeek',
createInitialBucketViewData:function(){
return{
buckets:dayOfWeekBuckets,
bucketSizes:dayOfWeekBucketSizes,
bucketIndexMap:dayOfWeekBucketsIndexMap};

},
getDomain:function(){return dayOfWeekBucketDomain},
getTickInfo:function(interval,widthOnScreen){return{
minor:{
ticks:d3.time.day,
format:function(date){return d3.time.format('%a')(date).toUpperCase()}}}}};




const Types={
Date:IncidentBucketType.fromConfig(dateBucketTypeConfig),
TimeOfDay12Hour:IncidentBucketType.fromConfig(timeOfDay12HourBucketTypeConfig),
TimeOfDay24Hour:IncidentBucketType.fromConfig(timeOfDay24HourBucketTypeConfig),
DayOfWeek:IncidentBucketType.fromConfig(dayOfWeekBucketTypeConfig)};


const AllTypesWith12HourLabels=[Types.Date,Types.TimeOfDay12Hour,Types.DayOfWeek];
const AllTypesWith24HourLabels=[Types.Date,Types.TimeOfDay24Hour,Types.DayOfWeek];

module.exports=IncidentBucketType;
//# sourceMappingURL=incidentBucketTypes.js.map
